import { StepConnector, styled, stepConnectorClasses } from "@mui/material";
import { MUI_STEPPER } from "@constants/mui.constants";

export const CustomStepConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: MUI_STEPPER.CONNECTOR.LINE_BACKGROUND_COLOR,
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: MUI_STEPPER.CONNECTOR.ACTIVE_LINE_COLOR,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: MUI_STEPPER.CONNECTOR.COMPLETED_LINE_COLOR,
  },
}));

export const CustomSubStepConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: MUI_STEPPER.CONNECTOR.LINE_BACKGROUND_COLOR,
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: MUI_STEPPER.CONNECTOR.ACTIVE_LINE_COLOR,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: MUI_STEPPER.CONNECTOR.COMPLETED_LINE_COLOR,
  },
}));
  